import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Hidden from '@mui/material/Hidden';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import HelpIcon from '@mui/icons-material/Help';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/components/authNavbarStyle.js';

const useStyles = makeStyles(styles);

export default function AuthNavbar(props) {
  const [open, setOpen] = React.useState(false);
  const handleDrawerToggle = () => setOpen(!open);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = routeName => (window.location.href.indexOf(routeName) > -1 ? true : false);
  const classes = useStyles();
  const { color, brandText } = props;
  const appBarClasses = cx({ [' ' + classes[color]]: color });
  const list = (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <NavLink to={'/login'} className={cx(classes.navLink, { [classes.navLinkActive]: activeRoute('/login') })}>
          <FingerprintIcon className={classes.listItemIcon} />
          <ListItemText primary={'Sign In'} disableTypography={true} className={classes.listItemText} />
        </NavLink>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink
          to={'/signup'}
          className={cx(classes.navLink, {
            [classes.navLinkActive]: activeRoute('/signup'),
          })}
        >
          <PersonAddIcon className={classes.listItemIcon} />
          <ListItemText primary={'Sign Up'} disableTypography={true} className={classes.listItemText} />
        </NavLink>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink
          to={'/forgotpassword'}
          className={cx(classes.navLink, {
            [classes.navLinkActive]: activeRoute('/forgotpassword'),
          })}
        >
          <HelpIcon className={classes.listItemIcon} />
          <ListItemText primary={'Forgot password'} disableTypography={true} className={classes.listItemText} />
        </NavLink>
      </ListItem>
    </List>
  );
  return (
    <AppBar position="static" className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden mdDown>{list}</Hidden>
        <Hidden mdUp>
          <Button
            className={classes.sidebarButton}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </Button>
        </Hidden>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={'right'}
            open={open}
            classes={{ paper: classes.drawerPaper }}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
          >
            {list}
          </Drawer>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

AuthNavbar.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  brandText: PropTypes.string,
};
